module.exports = new __parcel__URL__("favicon-temp-jpd.0a166bf7.png").toString();